<!-- Upload tab UI: list of uploaded images, form (name, colors, file), current image preview and color swatches. -->
<template>
    <div class="upload-image-v3">
        <!-- Section heading and close button -->
        <div
            class="tools_headding catgory_headding w-100 upload_heading"
            v-show="categoryHeading"
        >
            <h4 class="heading5 heading-space">Upload</h4>
            <a
                href="#"
                @click.prevent="$emit('close')"
                class="ml-auto"
                title="Close"
            >
                <img src="/maincss/images/tool_close.svg" alt="" />
            </a>
        </div>

        <!-- List of uploaded images (thumbnails, select, delete); shown when not in form mode -->
        <div
            v-if="uploadedImages.length > 0 && !showUploadForm"
            class="uploaded-images-list-section"
            v-show="categoryHeading"
        >
            <div class="tools_headding catgory_headding w-100 upload_heading">
                <h4 class="heading5 heading-space mt-4">Uploaded Images</h4>
            </div>
            <div class="categorys_open mt_14 shape_open new_after_upload_main_scroll_box">
                <div
                    id="avatarlist-top"
                    class="avatarlist d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                >
                    <div
                        v-for="(image, index) in uploadedImages"
                        :key="index"
                        class="form-check pl-0 img-polaroid add_shap_pd new_after_upload_mainbox_icon upload_image"
                    >
                        <label
                            class="checkbox_custom new_after_upload_delete_icon"
                            @click="$emit('delete-image', image.id)"
                        >
                            <img
                                class="delete_icon"
                                alt=""
                                src="/maincss/images/icons/delete_dark.svg"
                            />
                        </label>
                        <label class="checkbox_custom brand_logo_select">
                            <img
                                v-tooltip="image.image_name"
                                :src="image.image"
                            />
                            <input
                                type="radio"
                                :disabled="selectImageLoading === image.id"
                                @click="onSelectImage(image)"
                            />
                        </label>
                    </div>
                </div>
            </div>
            <div class="upload-new-image-btn-wrapper mt-3">
                <button
                    type="button"
                    class="btn btn-primary btn-block upload-new-image-btn"
                    @click="$emit('upload-new')"
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style="margin-right: 6px"
                    >
                        <path
                            d="M8 1V15M1 8H15"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                        />
                    </svg>
                    Upload New Image
                </button>
            </div>
        </div>

        <!-- Upload form: image name, desired number of colors, file picker (emit file-change for parent to handle) -->
        <div
            v-if="uploadedImages.length === 0 || showUploadForm"
            class="upload-form-section"
        >
            <div
                v-if="uploadedImages.length > 0 && showUploadForm"
                class="back-to-list-header mt-1"
                v-show="categoryHeading"
            >
                <button
                    type="button"
                    class="btn-back-to-list"
                    @click="$emit('back')"
                    title="Back to Uploaded Images"
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M12.5 15L7.5 10L12.5 5"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                    <span>Back</span>
                </button>
            </div>

            <div class="form-group mt_16 upload-group" v-show="categoryHeading">
                <label class="add_text_label label_text_add_text">Image Name</label>
                <span class="highlight"></span>
                <input
                    type="text"
                    placeholder="Enter here"
                    :value="uploadedImageName"
                    @input="$emit('update:uploadedImageName', $event.target.value)"
                    :disabled="!!currentUploadRecord"
                />
            </div>
            <div class="form-group mt_16 upload-group" v-show="categoryHeading">
                <label class="add_text_label label_text_add_text">Number of Colors</label>
                <span class="highlight"></span>
                <input
                    type="number"
                    placeholder="Enter number of colors"
                    :value="uploadedImageTopColors.length || desiredColorCount || ''"
                    @input="$emit('update:desiredColorCount', $event.target.value ? parseInt($event.target.value) : null)"
                    min="1"
                    max="20"
                    :disabled="uploadedImageTopColors.length > 0"
                    :title="uploadedImageTopColors.length > 0 ? 'Showing actual color count from uploaded image' : 'Enter desired number of colors'"
                />
            </div>
            <!-- Hide browse/drag-drop area when an image is already set (after upload or when selected from list) -->
            <div class="well mx-0 p-0 file_upload" v-show="categoryHeading && !uploadedDesignImage">
                <div class="Upload_tc">
                    <label class="font-weight-bold d-block">Choose a file to upload</label>
                    <!-- <label class="font-weight-bold">(Note: Svg images only editable)</label> -->
                </div>
                <form
                    action=""
                    method="post"
                    enctype="multipart/form-data"
                    @submit.prevent="$emit('submit-upload')"
                    data-vv-scope="uploadform"
                    class="choose_file_to_upload"
                >
                    <div
                        class="upload_box d-flex justify-content-center align-items-center flex-column upload-img-box"
                        @click="$refs.uploadDesignImage && $refs.uploadDesignImage.click()"
                    >
                        <input
                            class="crop_bdr d-none"
                            accept="image/*"
                            type="file"
                            ref="uploadDesignImage"
                            @click="$refs.uploadDesignImage && ($refs.uploadDesignImage.value = '')"
                            @change="$emit('file-change', $event)"
                        />
                        <img src="/maincss/images/cloud_computing.svg" alt="" />
                        <h4 class="mt_16 mb-0">Drag &amp; Drop or</h4>
                        <h4 class="mb-0">
                            <a href="#" style="color: #0079c1">Browse</a> Your Computer
                        </h4>
                    </div>
                    <div class="upload_note upload-img-note">
                        <div class="left_ins">
                            <p>Accepted File Types</p>
                            <p>(Max Size. 5 MB)</p>
                        </div>
                        <!-- <div class="rgt_ins"><p>SVG</p></div> -->
                    </div>
                    <div class="upload_apply_button"></div>
                </form>
                <div class="bottom_upload_text">
                    <p>Have a different type of file? <a href="mailto:">Email</a> it to us!</p>
                </div>
            </div>

            <!-- Current image preview, color swatches (edit/delete/add), and inline color picker -->
            <div
                v-if="uploadedDesignImage"
                class="current-upload-section mt-3"
                v-show="categoryHeading"
            >
                <div class="current-upload-header">
                    <h6 class="font-weight-bold mb-2">
                        Current Image: {{ currentImageDisplayName }}
                    </h6>
                </div>
                <div v-if="uploadedDesignImage" class="uploaded-image-preview mb-3">
                    <img :src="uploadedDesignImage" alt="Uploaded" class="preview-thumbnail" />
                </div>
                <div
                    v-if="uploadedImageTopColors.length > 0"
                    class="uploaded-image-colors-section"
                >
                    <span class="font-weight-bold d-block mb-2 small">
                        Image Colors ({{ uploadedImageTopColors.length }})
                    </span>
                    <div class="color-boxes-grid">
                        <div
                            v-for="(color, i) in uploadedImageTopColors"
                            :key="'color-' + i"
                            class="color-box-wrapper"
                        >
                            <div
                                class="uploaded-color-swatch filled editable"
                                :style="{ background: color }"
                                :title="color"
                                @click="$emit('edit-color', i)"
                            >
                                <div
                                    v-show="uploadedImageTopColors.length > 1"
                                    class="color-delete-icon"
                                    @click.stop.prevent="$emit('delete-color', i)"
                                    @mousedown.stop
                                    role="button"
                                    tabindex="0"
                                    title="Delete color"
                                >
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.5 3H2.5H10.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M4 3V2C4 1.73478 4.10536 1.48043 4.29289 1.29289C4.48043 1.10536 4.73478 1 5 1H7C7.26522 1 7.51957 1.10536 7.70711 1.29289C7.89464 1.48043 8 1.73478 8 2V3M9.5 3V10C9.5 10.2652 9.39464 10.5196 9.20711 10.7071C9.01957 10.8946 8.76522 11 8.5 11H3.5C3.23478 11 2.98043 10.8946 2.79289 10.7071C2.60536 10.5196 2.5 10.2652 2.5 10V3H9.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                            <span class="small color-hex-label">{{ color }}</span>
                        </div>
                        <div
                            v-for="emptyIndex in emptyBoxesCount"
                            :key="'empty-' + emptyIndex"
                            class="color-box-wrapper"
                        >
                            <div
                                class="uploaded-color-swatch empty"
                                @click="$emit('add-color', uploadedImageTopColors.length + emptyIndex - 1)"
                            >
                                <span class="plus-icon">+</span>
                            </div>
                            <span class="small color-hex-label">Add</span>
                        </div>
                    </div>
                    <div v-if="uploadedImageTopColors.length > 0" class="add-more-color-section mt-3">
                        <a href="javascript:void(0)" class="add-more-color-link" @click.prevent="$emit('add-new-color-box')">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 4px">
                                <path d="M7 1V13M1 7H13" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                            </svg>
                            Add More Color
                        </a>
                    </div>
                </div>
                <div v-if="uploadedImageTopColors.length === 0" class="no-colors-message">
                    <p class="text-muted small mb-0">No distinct colors detected in this image.</p>
                </div>
                <!-- Inline color picker -->
                <div v-if="colorPickerVisible" class="color-picker-inline mt-3">
                    <chrome-picker v-model="editingColorObjectLocal" />
                    <div class="color-picker-actions mt-2">
                        <button type="button" class="btn btn-sm btn-primary" @click="$emit('save-color')">Save</button>
                        <button type="button" class="btn btn-sm btn-secondary ml-2" @click="$emit('close-picker')">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Chrome } from "vue-color";
import ApiService from "@/common/api.service";

// Presentational component: receives upload state as props, emits user actions for parent to handle (API, canvas, colors).
export default {
    name: "UploadImageV3",
    components: { "chrome-picker": Chrome },
    props: {
        categoryHeading: { type: Boolean, default: true },
        uploadedImages: { type: Array, default: () => [] },
        showUploadForm: { type: Boolean, default: false },
        uploadedImageName: { type: String, default: "" },
        currentUploadRecord: { type: Object, default: null },
        uploadedDesignImage: { type: String, default: null },
        uploadedImageTopColors: { type: Array, default: () => [] },
        desiredColorCount: { type: Number, default: null },
        emptyBoxesCount: { type: Number, default: 0 },
        colorPickerVisible: { type: Boolean, default: false },
        editingColorObject: { type: Object, default: () => ({ hex: "#000000" }) }
    },
    emits: [
        "close",
        "back",
        "upload-new",
        "file-change",
        "submit-upload",
        "select-image",
        "delete-image",
        "update:uploadedImageName",
        "update:desiredColorCount",
        "update:editingColorObject",
        "edit-color",
        "add-color",
        "save-color",
        "close-picker",
        "delete-color",
        "add-new-color-box"
    ],
    data() {
        return {
            selectImageLoading: null // id of image being fetched on listing click
        };
    },
    methods: {
        // On listing click: fetch full upload (including image_colors) then emit so edit screen shows colors.
        onSelectImage(image) {
            if (!image || !image.id) {
                const imgUrl = image && image.image ? image.image : null;
                this.$emit("select-image", { image: imgUrl, image_data: image });
                return;
            }
            this.selectImageLoading = image.id;
            ApiService.get("/design-studio-upload/" + image.id)
                .then(({ data }) => {
                    const upload_data = data.upload_data || image;
                    this.$emit("select-image", { image: image.image, image_data: upload_data });
                })
                .catch(() => {
                    this.$emit("select-image", { image: image.image, image_data: image });
                })
                .finally(() => {
                    this.selectImageLoading = null;
                });
        }
    },
    computed: {
        // Display name: from saved upload record or typed name.
        currentImageDisplayName() {
            if (this.currentUploadRecord && this.currentUploadRecord.image_name) {
                return this.currentUploadRecord.image_name;
            }
            return this.uploadedImageName || "Untitled";
        },
        // Two-way binding for color picker without mutating prop; emit update for parent.
        editingColorObjectLocal: {
            get() {
                return this.editingColorObject;
            },
            set(val) {
                this.$emit("update:editingColorObject", val);
            }
        }
    }
};
</script>

<style scoped>
.uploaded-color-swatch {
    width: 42px;
    height: 42px;
    border-radius: 4px;
    border: 1px solid #ddd;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;
}
.color-delete-icon {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 20px;
    height: 20px;
    background: #dc3545;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    transition: all 0.2s;
    z-index: 10;
}
.color-delete-icon:hover {
    background: #c82333;
    transform: scale(1.1);
}
.color-delete-icon svg {
    pointer-events: none;
}
.uploaded-color-swatch.filled.editable {
    cursor: pointer;
}
.uploaded-color-swatch.filled.editable:hover {
    border-color: #1d6cb5;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.uploaded-color-swatch.empty {
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px dashed #ccc;
}
.uploaded-color-swatch.empty:hover {
    border-color: #1d6cb5;
    background: #f8f9fa;
}
.uploaded-color-swatch .plus-icon {
    font-size: 24px;
    color: #999;
    line-height: 1;
}
.color-boxes-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
    gap: 12px;
    margin-top: 8px;
}
.color-box-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}
.color-hex-label {
    font-size: 11px;
    color: #666;
    text-align: center;
    word-break: break-all;
}
.color-picker-inline {
    border-top: 1px solid #ddd;
    padding-top: 12px;
    margin-top: 0 !important;
    position: relative;
    width: 100%;
}
.color-picker-inline .vc-chrome {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
    width: 220px !important;
    position: relative !important;
    margin-top: 0 !important;
    top: 0 !important;
}
.color-picker-actions {
    display: flex;
    gap: 8px;
    justify-content: flex-start;
    margin-top: 10px !important;
}
/* Save button: primary blue, white text */
.color-picker-actions .btn-primary {
    background-color: #0079c1 !important;
    border-color: #0079c1 !important;
    color: #fff !important;
    padding: 8px 18px !important;
    min-width: 72px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    border-radius: 4px !important;
    cursor: pointer !important;
}
.color-picker-actions .btn-primary:hover {
    background-color: #005a8d !important;
    border-color: #005a8d !important;
    color: #fff !important;
}
/* Cancel button: grey, dark text */
.color-picker-actions .btn-secondary {
    background-color: #6c757d !important;
    border-color: #6c757d !important;
    color: #fff !important;
    padding: 8px 18px !important;
    min-width: 72px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    border-radius: 4px !important;
    cursor: pointer !important;
}
.color-picker-actions .btn-secondary:hover {
    background-color: #5a6268 !important;
    border-color: #545b62 !important;
    color: #fff !important;
}
.current-upload-section {
    padding: 15px;
    background: #f8f9fa;
    border-radius: 6px;
    margin-top: 15px;
}
.current-upload-header h6 {
    color: #333;
    font-size: 14px;
    margin-bottom: 10px;
}
.uploaded-image-preview {
    text-align: center;
    padding: 10px;
    background: white;
    border-radius: 4px;
    border: 1px solid #ddd;
}
.preview-thumbnail {
    max-width: 100%;
    max-height: 150px;
    object-fit: contain;
}
.uploaded-image-colors-section {
    margin-top: 15px;
}
.add-more-color-section {
    text-align: left;
    padding-top: 10px;
    border-top: 1px solid #e0e0e0;
}
.add-more-color-link {
    display: inline-flex;
    align-items: center;
    color: #0079c1;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.2s;
}
.add-more-color-link:hover {
    color: #005a8d;
    text-decoration: none;
}
.upload-new-image-btn-wrapper {
    padding: 0 12px;
}
.upload-new-image-btn {
    background: #0079c1 !important;
    color: #fff !important;
    border: none !important;
    border-radius: 4px !important;
    padding: 12px 16px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    cursor: pointer !important;
    transition: all 0.3s ease !important;
}
.upload-new-image-btn:hover {
    background: #005a8d !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 8px rgba(0, 121, 193, 0.3) !important;
}
.btn-back-to-list {
    background: transparent !important;
    color: #0079c1 !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    padding: 8px 0 !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    display: flex !important;
    align-items: center !important;
    gap: 6px !important;
    cursor: pointer !important;
    transition: all 0.3s ease !important;
    width: auto !important;
}
.btn-back-to-list:focus {
    outline: none !important;
    box-shadow: none !important;
}
.uploaded-images-list-section {
    padding: 0;
}
</style>
